export enum SequenceSettingCode {
  EMAIL_LIMIT = 'email-limit', // Email limit of prospect in a single day
  UNSUBSCRIBE_LINK = 'unsubscribe-link', // Unsubscribe link in email
  UNSUBSCRIBE_TEXT = 'unsubscribe-text', // Unsubscribe text in email
  UNSUBSCRIBE_VIA_EMAIL_HEADER = 'unsubscribe-via-email-header',
  MARK_AS_FINISHED = 'mark-as-finished', // Consider the prospect as finished if a reply is received
  SCHEDULE = 'schedule',
  TRACK_LINK_CLICKS = 'track-link-clicks', // To toggle activation of click tracking in emails.
  TRACK_EMAIL_OPENS = 'track-email-opens', // To toggle activation of click tracking on open email
  IS_SAMPLE_SEQUENCE = 'is-sample-sequence',
  TRACK_RISKY_PROSPECTS = 'email-risky-prospects',
  DEAL_VALUE = 'deal-value',
  CC = 'cc',
  BCC = 'bcc',
  TEXT_ONLY_EMAIL = 'text-only-email',
  FIRST_STEP_TEXT_ONLY_EMAIL = 'first-step-text-only-email',
  SHOW_TEXT_ONLY_OPTION = 'show-text-only-option',
  ESP_MATCHING = 'esp-matching',
  SEQUENCE_SETTING_VISITED = 'sequence-setting-visited',
  SEQUENCE_PROSPECT_ENROLLMENT_LIMIT = 'prospect-enrollment-limit',
  SEQUENCE_PROSPECT_ENROLLMENT_AVAILABLE_LIMIT = 'prospect-enrollment-available-limit',
  SEQUENCE_PROSPECT_ENROLLMENT_RECURRENCE = 'prospect-enrollment-recurrence',
  SEQUENCE_PROSPECT_ENROLLMENT_WHEN_TO_ENROLL = 'prospect-enrollment-when-to-enroll',
}

export enum SequencePrioritySettingCode {
  FIRST_TO_LAST = 'first-to-last',
  LAST_TO_FIRST = 'last-to-first',
  EQUAL = 'equal',
  AGGRESSIVE_FISRT = 'aggressive-first',
}

export enum TextOnlyEmailSettingValue {
  TEXT_ONLY_DISABLED = '0',
  REMOVE_STYLING_AUTOMATICALLY = '1',
  TEXT_ONLY_EMAIL = '2',
}
